import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IExplorableItemTypeInfo } from '~src/spacesPlatform/models/resourceInfoParts';
import { ICreatedItem } from '~src/spacesPlatform/models/resourceParts';

export interface UpdateServerWelcomeChannelInfoParams {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export interface IServerWelcomeChannelInfo extends ICreatedItem, IExplorableItemTypeInfo<'site'> {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export type IUpdateServerWelcomeChannelInfoResult = IResult & IServerWelcomeChannelInfo;

export class UpdateServerWelcomeChannelInfoRequest extends Request<UpdateServerWelcomeChannelInfoParams, IUpdateServerWelcomeChannelInfoResult> {
  constructor(params: UpdateServerWelcomeChannelInfoParams) {
    super('updateServerWelcomeChannelInfo', params);
  }
}
